export const incomeContent = [
    'KİŞİ / ŞİRKET ADI',
    'TAHSİL EDEN',
    'İŞLEM TARİHİ',
    'GELİR DURUMU',
    'ODA',
    'TOPLAM TUTAR',
    '(1. KALEM) AÇIKLAMA',
    '(1. KALEM) GELİR KANALI',
    '(1. KALEM) MİKTAR',
    '(1. KALEM) GELİR TİPİ',
    '(2. KALEM) AÇIKLAMA',
    '(2. KALEM) GELİR KANALI',
    '(2. KALEM) MİKTAR',
    '(2. KALEM) GELİR TİPİ',
    '(3. KALEM) AÇIKLAMA',
    '(3. KALEM) GELİR KANALI',
    '(3. KALEM) MİKTAR',
    '(3. KALEM) GELİR TİPİ',
];

export const expenseContent = [
    'KİŞİ / ŞİRKET ADI',
    'TAHSİL EDEN',
    'İŞLEM TARİHİ',
    'GİDER DURUMU',
    'ODA',
    'TOPLAM TUTAR',
    '(1. KALEM) AÇIKLAMA',
    '(1. KALEM) GİDER KANALI',
    '(1. KALEM) MİKTAR',
    '(1. KALEM) GİDER TİPİ',
    '(2. KALEM) AÇIKLAMA',
    '(2. KALEM) GİDER KANALI',
    '(2. KALEM) MİKTAR',
    '(2. KALEM) GİDER TİPİ',
    '(3. KALEM) AÇIKLAMA',
    '(3. KALEM) GİDER KANALI',
    '(3. KALEM) MİKTAR',
    '(3. KALEM) GİDER TİPİ',
];

export const memberContent = [
    'İL',
    'ODA SİCİL NO',
    'AD',
    'SOYAD',
    'ESKİ SOYAD',
    'TC KİMLİK NO',
    'MAİL',
    'CİNSİYET',
    'BABA ADI',
    'ANA ADI',
    'DOĞUM YERİ',
    'DOĞUM TARİHİ',
    'KİMLİK TİPİ',
    'KİMLİK SERİ NO',
    'KİMLİK KAYIT NO',
    'KİMLİK SON GEÇERLİLİK TARİHİ',
    'KAN GRUBU',
    'MEDENİ HALİ',
    'İŞ TEL',
    'GSM TEL',
    'EV TEL',
    'İKAMET ADRESİ',
    'İKAMET EDİLEN ŞEHİR',
    'İKAMET EDİLEN İLÇE',
    'İKAMET EDİLEN SEMT',
    'İŞ ADRESİ',
    'İŞ YERİ ŞEHİR',
    'İŞ YERİ İLÇE',
    'İŞ YERİ SEMT',
    'ODA KAYIT TARİHİ',
    'MÜESSESE RUHSATNAMESİ BELGE NO',
    'MÜESSESE RUHSATNAMESİ BELGE TARİHİ',
    'MEZUNİYET BELGE TİPİ',
    'ÜNİVERSİTE/RUHSAT VEREN KURUM',
    'DİPLOMA NO./GÖZL.RUHSAT. CİLT-YAPRAK NO',
    'MEZUNİYET/GÖZL.RUHSAT. TARİHİ',
    'VERGİ DAİRESİ ADI',
    'VERGİ NO',
    'ÜYE ÇALIŞIYOR',
    'KENDİ İŞ YERİ',
    'MESUL MÜDÜR',
    'İŞSİZ',
    'ÇALIŞMA BELGELİ PERSONEL',
    'KAMU PERSONELİ',
    'ECZACI',
    'MÜESSESE/FİRMA ADI',
    'MÜESSESE SAHİBİ',
    'KULLANICI ADI',
];

export const feeDefinitonContent = [
    'ÜYE AD',
    'ÜYE SOYAD',
    'ODA ADI',
    'ODA SİCİL NO',
    'İL',
    'TAHAKKUK YILI',
    'TAHAKKUK TİPİ',
    'TAHAKKUK TUTARI',
    'TAHAKKUK OLUŞTURMA DURUMU',
];

export const accrualContent = [
    'ÜYE AD',
    'ÜYE SOYAD',
    'ODA ADI',
    'ODA SİCİL NO',
    'İL',
    'TAHAKKUK YILI',
    'TAHAKKUK TİPİ',
    'TAHAKKUK TUTARI',
    'TAHSİL EDİLME DURUMU',
    'TAHSİL EDEN',
    'İŞLEM TARİHİ',
];
export const balanceContent = [
    'GELİR TİPİ',
    'TOPLAM TUTAR',
    'GİDER TİPİ',
    'TOPLAM TUTAR',
];
export const accrualStatsContent = [
    'ODA',
    'TİP',
    'YIL',
    'TAHSİL EDİLEN',
    'TAHSİL EDİLMEYEN',
    'TOPLAM',
    'TAHSİLAT YÜZDESİ',
];



// WEBPACK FOOTER //
// ./src/constants/exportcontent.js